/** @format */

import PromoBannerCloseBtn from '@/assets/icons/promo_banner_close_btn.svg';
import React, { memo, useEffect, useState } from 'react';
import { apiPromoBanner, PromoBannerRequest, PromoBannerResponse } from '../../../api/apiPromoBanner';
import { useAppTranslation } from '../../../i18n/declarations';
import { TLocale } from '../../../utils/gatsby/types';

type PromoBannerProps = {
  page: 'pdp' | 'plp';
  layout?: 'desktop' | 'mobile';
  promoBannerInfo: PromoBannerRequest;
};
import { IconPromoBanner, PromoBannerContainer, TextPromoBanner } from './PromoBanner.style';

export const PromoBanner = memo(({ promoBannerInfo, page, layout = undefined }: PromoBannerProps) => {
  const { intl } = useAppTranslation();
  const { buildingId = null, bedCode, flatId, cityId } = promoBannerInfo;
  const [show, setShow] = useState(false);
  const [info, serInfo] = useState<PromoBannerResponse | undefined>(undefined);

  useEffect(() => {
    if ((bedCode || cityId) && info == undefined) {
      const loadPromoBanner = async () => {
        const res = await apiPromoBanner({
          buildingId,
          bedCode,
          flatId,
          cityId,
        });

        if (res) {
          serInfo(res);
          setShow(true);
        }
      };
      loadPromoBanner();
    }
  }, [bedCode, cityId, info]);

  if (!show) return null;

  const isHTML = /<\/?[a-z][\s\S]*>/i.test(info?.translations[intl.locale as TLocale] || '');

  return (
    <PromoBannerContainer $page={page} $layout={layout}>
      {isHTML ? (
        <TextPromoBanner dangerouslySetInnerHTML={{ __html: info?.translations[intl.locale as TLocale] || '' }} />
      ) : (
        <TextPromoBanner>{info?.translations[intl.locale as TLocale]}</TextPromoBanner>
      )}

      <IconPromoBanner onClick={() => setShow(false)} icon={PromoBannerCloseBtn} width={10} height={10} />
    </PromoBannerContainer>
  );
});
